export class CognitoStateModel {
  isAuthenticated = false;
  idToken: string;
  accessToken: string;
}
